export default __webpack_public_path__ + "static/media/fail.79cf6a30.mp3";